import api, { apiErrorHandler } from "api";
import { DaFeedbackConstants } from "constants/constants";
import { RootState } from "reducers/rootReducer";
import { Dispatch } from "redux";

export const getDaFeedbackData = (params: any) => (dispatch: Dispatch) => {
  const onError = () => dispatch({ type: DaFeedbackConstants.DA_FEEDBACK_ERROR });
  dispatch({ type: DaFeedbackConstants.DA_FEEDBACK_LOADING });
  api
    .getDaFeedbackList(params)
    .then((res) => {
      if (res?.data) {
        dispatch({
          type: DaFeedbackConstants.DA_FEEDBACK_GET_LIST_SUCCESS,
          payload: res?.data.results,
        });
      }
    })
    .catch(apiErrorHandler(onError));
};

export const getDaFeedbackReportData = (id: number) => (dispatch: Dispatch) => {
  const onError = () => dispatch({ type: DaFeedbackConstants.DA_FEEDBACK_ERROR });
  dispatch({ type: DaFeedbackConstants.DA_FEEDBACK_LOADING });
  api
    .getDaFeedbackReport(id)
    .then((res) => {
      if (res?.data) {
        dispatch({
          type: DaFeedbackConstants.DA_FEEDBACK_GET_REPORT_SUCCESS,
          payload: res?.data,
        });
      }
    })
    .catch(apiErrorHandler(onError));
};

export const updateDaFeedbackReport =
  (data: any) => (dispatch: Dispatch, getStore: () => RootState) => {
    const onError = () => dispatch({ type: DaFeedbackConstants.DA_FEEDBACK_ERROR });
    dispatch({ type: DaFeedbackConstants.DA_FEEDBACK_LOADING });
    const { currentReport } = getStore()?.daFeedbackTable;

    const updatedData = data.type === 1 ? {attendance_status: data.data} : currentReport?.schedule_content

    api
      .updateDaFeedbackReport(data)
      .then((res) => {
        if (res) {
          dispatch({
            type: DaFeedbackConstants.DA_FEEDBACK_UPDATE_REPORT_SUCCESS,
            payload: { ...currentReport, schedule_content: updatedData, is_submitted: true },
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const daFeedbackChangeFilters =
  (data: any) => (dispatch: Dispatch, getStore: () => RootState) => {
    const { feedbackFilters } = getStore()?.daFeedbackTable;
    dispatch({
      type: DaFeedbackConstants.DA_FEEDBACK_CHANGE_FILTERS,
      payload: { ...feedbackFilters, ...data },
    });
  };